module.exports = __webpack_public_path__ + "static/handshake-min-539f69e6e353f81de42fffa45c171bf4.jpg";